export const REACT_APP_SEARCH = process.env.REACT_APP_SEARCH;
export const REACT_APP_INTERVENTI = process.env.REACT_APP_INTERVENTI;
export const OldCostituenteSite = false;



/*
\\intrafile\legislature.intra.camera.it\Altre_Sezioni\assemblea_costituente
https://legislature.camera.it/altre_sezioni/assemblea_costituente/composizione/costituenti/attivitacostituente.asp?pref=AttNonLeg&deputato=1Nd25270
https://legislature.camera.it/altre_sezioni/assemblea_costituente/composizione/costituenti/ApriPagPdf.asp?NumSed=131&NumPag=4230&FonteEstesa=Assemblea
*/
